<template>

<v-flex xs12 fill-height>
    <ApolloQuery
            class="fill-height"
            fetchPolicy="network-only"
            :query="require('../graphql/queries/stations.gql')"
            client-id="clientPrivate">
        <template v-slot="{ result: { loading, error, data } }">

            <template v-if="data">
                <map-with-position :markers="data.stations.nodes"  :initial-zoom="12"
                                   :initial-center="{lat: 45, lng: 10}"></map-with-position>
            </template>

        </template>
    </ApolloQuery>
</v-flex>



</template>


<script>

    import MapWithPosition from "../components/MapWithPosition"


    export default {
        name: 'PicksUp',
        components: {
            MapWithPosition
        }

    }
</script>


<style lang="scss" scoped>

</style>